__turbopack_context__.v({
  "affirmButtonWrapper": "payment-button-module-scss-module__h7AJsq__affirmButtonWrapper",
  "loading": "payment-button-module-scss-module__h7AJsq__loading",
  "paymentAmount": "payment-button-module-scss-module__h7AJsq__paymentAmount",
  "paymentButton": "payment-button-module-scss-module__h7AJsq__paymentButton",
  "paymentButtonWrapper": "payment-button-module-scss-module__h7AJsq__paymentButtonWrapper",
});
